
const links = {
  dribble: "https://dribbble.com/brandonzacharias",
  linkedin: "https://www.linkedin.com/in/brandon-zacharias/",
  email: "brandonzchrs@gmail.com"
}

export default links